import {useState} from 'react'

export default (val = false) => {
  const [bool, setBool] = useState(val)
  const toggleBool = () => setBool(!bool)
  return [bool, setBool, toggleBool]
}
